import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import NavMenu from "./Menu";
import { Container } from "@mui/material";

import ParticlesBg from "particles-bg";
import "../utils/commentstyles.css";
import "../utils/style.css"
import '../utils/collagestyles.css'
import useWindowDimensions from "../utils/windowcheck";
import CommentsBlock from "simple-react-comments";
import { commentsAtom } from "./atoms";
import { useSetRecoilState } from "recoil";
import axios from "axios";
function parseDate(input) {
  if (input === "") return;
  var parts = input.match(/(\d+)/g);
  // new Date(year, month [, date [, hours[, minutes[, seconds[, ms]]]]])
  return new Date(parts[0], parts[1] - 1, parts[2]); // months are 0-based
}

const PuppyCam = () => {
  const { width, height } = useWindowDimensions();
  const [inputValue, setInputValue] = useState("");
  const [active, setActive] = useState(true);
  const comments = useRecoilValue(commentsAtom);
  const setComments = useSetRecoilState(commentsAtom);
  const [name, setName] = useState("Anonymous");
  const [createdAt, setDate] = new useState(new Date());
  const [avatarUrl, setAvatarUrl] = useState(
    "https://snootly.s3.amazonaws.com/favpng_online-chat.png"
  );
  const [authorUrl, setAuthorUrl] = useState("");

  const addItem = (text) => {
    if(name === null) setName("Anonymous");

    setComments((oldcomments) => [
      ...oldcomments,
      {
        avatarUrl: avatarUrl,
        authorUrl: "",
        fullName: name,
        createdAt: createdAt,
        text: text,
      },
    ]);
    // post this to the database?
    axios.post("/comment", { avatarUrl, authorUrl, name, createdAt, text });
  };

  const onChange = ({ target: { value } }) => {
    setInputValue(value);
  };

  const handleTextChange = (text) => {
    setName(text);

    if (text !== "") {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  useEffect(() => {
    

    const fetchData = async () => {
      var resp = await axios.get("/getcomments");

      if (resp.data.length === 0) return;
      for (var i = 0; i < resp.data.length; i++) {
        setComments((oldcomments) => [
          ...oldcomments,
          {
            avatarUrl: resp.data[i].avatarUrl,
            authorUrl: "",
            fullName: resp.data[i].name,
            createdAt: parseDate(resp.data[i].createdAt),
            text: resp.data[i].text,
          },
        ]);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <ParticlesBg num={15} type="circle" bg={true} />
      <NavMenu />
      <br></br> <br></br>
      <div class="flex-container2">
        <body class="body" align="relative">
          <br></br>
          <h1> Fur-Babies In Real-Time!</h1>
          <iframe
            key="puppyone"
            title="Puppy One"
            type="text/html"
            frameborder="2"
            width={width / 2}
            height={height / 2}
            src="//video.nest.com/embedded/live/ufuT60cR5K?autoplay=1"
            allowfullscreen="true"
          ></iframe>{" "}
          <br></br> <br></br>
          <br></br>
          <br></br>
          <iframe
            key="puppytwo"
            title="Puppy Two "
            type="text/html"
            frameborder="2"
            width={width / 2}
            height={height / 2}
            src="//video.nest.com/embedded/live/1HZ40ExPE6?autoplay=1"            
            allowfullscreen="true"
          ></iframe>{" "}
          <br></br>
          <br></br>
        
         
          <br></br> <br></br>   
          <label class="flex-item2" htmlFor="name">
            Name:
            <input
              type="name"
              value={name}
              onChange={(e) => handleTextChange(e.target.value)}
              onFocus={() => setActive({ active: true })}
              onBlur={() => setActive({ active: false })}
            />
          </label><br></br><br></br>  <br></br>
          <br></br>
          
          <Container className="container" maxWidth="sm">
           <div class="flexcontainer">
          <CommentsBlock
              comments={comments}
              signinUrl={"/puppycam"}
              avatarUrl={avatarUrl}
              isLoggedIn={true}
              createdAt={new Date().toDateString}
              reactRouter={false} // set to true if you are using react-router
              onSubmit={addItem}
            />
            </div>
            </Container>
       
          <br></br>
        
          <br></br>
          <br></br>
        </body>
      </div>
    </>
  );
};
export default PuppyCam;
